import type { ShareMode } from './graphqlTypes'

import { getShareMode } from '../utils/getShareMode'
import type { MapperContext } from './types'

// `saveToDraft` is not derivable from `scheduleOption` alone, so it rides on
// the context and passes through unchanged.
export function mapShareMode(ctx: MapperContext): {
  mode: ShareMode
  dueAt?: string
  saveToDraft?: boolean
} {
  const mode = getShareMode(ctx.scheduleOption)

  // Legacy `customScheduleTime` is unix seconds; `dueAt` is an ISO DateTime.
  const dueAt =
    ctx.scheduleOption === 'FixedTime' && ctx.customScheduleTime != null
      ? new Date(ctx.customScheduleTime * 1000).toISOString()
      : undefined

  return {
    mode,
    ...(dueAt ? { dueAt } : {}),
    // Send the flag whenever it's set: true = save as draft, false = schedule.
    // A false must be sent, not omitted — the server keeps the post's current
    // status when saveToDraft is absent, which would strand a draft the caller
    // is trying to schedule.
    ...(ctx.saveToDraft != null ? { saveToDraft: ctx.saveToDraft } : {}),
  }
}
